import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  RocketOutlined,
  QuestionCircleOutlined,
  FastForwardOutlined,
} from '@ant-design/icons';
import {
  Row,
  Col,
  Card,
  Result,
  message,
  PageHeader,
  Button,
  Typography,
  Divider,
  Alert,
  Layout,
  Modal,
  Tag,
  Progress,
  Statistic,
  InputNumber,
} from 'antd';
import { UserOutlined, SettingOutlined, PlusOutlined, MinusOutlined, CheckCircleOutlined, SyncOutlined } from '@ant-design/icons';
import axios from 'axios';

import moment from 'moment';
import TrialPage from './trialPage';
import { setDriftState } from '../auth/authActions';
import JiraBilling from './jiraBilling';
import { sendMessageOnchat } from '../../utils/utils';

const { Title, Text, Link } = Typography;
const uuidv4 = require('uuid/v4');
// const JiraBilling=require("./jiraBilling")

class Billing extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      isProfileView: true,
      assistant_name: 'Troopr Assistant',
      team: {},
      skills: [],
      defaultSkill: '',
      nameLoading: false,
      defaultLoading: false,
      info: {},
      activeUsers: {},
      jiraSkill: {},
      numberofActiveCheckIns: 0,
      pricings: [],
      addOnQuantities: {},
      addOnModal: null,   // { planId, action, planName, qty, submitting }

      // showSelfPlans: false,
    };

    this.getText = this.getText.bind(this);
    this.getButton = this.getButton.bind(this);
    this.getBillingData = this.getBillingData.bind(this);
    this.getLimitsText = this.getLimitsText.bind(this);
    this.setBillingData = this.setBillingData.bind(this);
  }
  setBillingData = (paymentInfo) => {


    this.setState({
      info: paymentInfo,

    });
  }

  getBillingData = async () => {

    const billingPromise = axios.get(
      '/auth/troopr_billing/payementInfo/' + this.props.match.params.wId
    );

    // let activeUsers = axios.get("/auth/troopr_billing/getActiveUsers/" + this.props.match.params.wId)

    const pricing = axios.get('/auth/pricing');

    const data = await Promise.all([billingPromise, pricing])
    console.log("data", data)
    const { skills } = this.props;
    let billing = data[0] && data[0].data;
    let pricings = data[1].data.pricings;
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    const wikiSkill = skills.find((skill) => skill.key === 'wiki');
    const helpdeskSubSkill =
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.sub_skills.find(
        (ss) => ss.key === 'jira_service_desk'
      );
    if (!helpdeskSubSkill) {
      pricings = pricings.filter((product) => product.key !== 'helpdesk');
    }
    if (!(wikiSkill && wikiSkill.skill_metadata)) {
      pricings = pricings.filter((product) => product.key !== 'wiki');
    }

    const paymentInfo = billing && billing.paymentInfo;
    const hasPending = !!(paymentInfo && paymentInfo.pending_action && paymentInfo.pending_action.type);

    this.setState({
      info: paymentInfo,
      pricings: pricings,
      loading: false,
    });

    // Start or stop polling based on whether there's a pending action
    if (hasPending && !this._pollInterval) {
      this._pollInterval = setInterval(() => {
        this.getBillingData();
      }, 3000);
    } else if (!hasPending && this._pollInterval) {
      clearInterval(this._pollInterval);
      this._pollInterval = null;
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.getBillingData();
  }

  componentWillUnmount() {
    if (this._pollInterval) {
      clearInterval(this._pollInterval);
      this._pollInterval = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.skills !== this.props.skills ||
      prevState.pricings.length !== this.state.pricings.length
    ) {
      const { skills } = this.props;
      const jiraSkill = skills.find((skill) => skill.key === 'jira');
      const wikiSkill = skills.find((skill) => skill.key === 'wiki');
      const helpdeskSubSkill =
        jiraSkill &&
        jiraSkill.skill_metadata &&
        jiraSkill.skill_metadata.sub_skills.find(
          (ss) => ss.key === 'jira_service_desk'
        );
      if (!helpdeskSubSkill && !(wikiSkill && wikiSkill.skill_metadata)) {
        const updatedPricings = this.state.pricings.filter(
          (product) => product.key !== 'wiki' && product.key !== 'helpdesk'
        );
        this.setState({
          pricings: updatedPricings,
        });
      }
    }
  }

  getPrice = () => {
    const { workspace } = this.props;
    const { jiraSkill, numberofActiveCheckIns, activeUsers } = this.state;
    // const activeusers = activeUsers.quantity
    if (workspace && jiraSkill._id) {
      if (jiraSkill.linked) {
        if (workspace.membershipCount.length > 25) return '49';
        else return '10';
      } else if (!jiraSkill.linked) {
        if (workspace.membershipCount.length > 25) return '19';
        else if (
          workspace.membershipCount.length < 26 &&
          numberofActiveCheckIns > 1
        )
          return '19';
        else return '0';
      }
    }
  };

  getPlan = () => {
    const { info } = this.state;
    const { workspace } = this.props;
    if (workspace.billing_status == 'free') {
      return 'Free Plan';
    } else if (workspace.is_enterprise) {
      return 'Troopr Enterprise Plan';
    } else if (info.payment_app == 'jira') {
      return 'Your  Atlassian License is Active.';
    } else {
      if (info.plans && info.plans.length > 0) {
        let plans = [];

        this.state.pricings.forEach((p) => {
          let isPlan = false;
          if (p.key) {
            p.products.forEach((prd) => {
              prd.prices.forEach((price) => {
                isPlan = info.plans.find((id) => id === price.price_id);
                if (isPlan) {
                  plans.push(prd.name);
                }
              });
            });
          } else {
            isPlan = info.plans.find((id) => id === p.plan_id);
            if (isPlan) {
              plans.push(p.name);
            }

            // dbPlans.push({price_id:p.plan_id,frequency:p.billing_cycle,name:p.name})
          }
        });
        // let plans=  this.state.pricings.filter(p=>!p.key).find(plan=>(info.plan_id==plan.plan_id))
        return plans.length > 0 ? plans.join(', ') : 'Troopr Plan';
      } else if (info && info.payment_app === 'appsumo') {
        const products =
          workspace.subscribed_products &&
            workspace.subscribed_products.products
            ? workspace.subscribed_products.products
            : [];
        let text = '';
        products.forEach((product, index) => {
          if (product === 'jira_software') text += 'Projects (Jira) Pro';
          else if (product === 'jira_service_desk')
            text += 'HelpDesk (Jira) Pro';
          else if (product === 'jira_reports') text += 'Reports (Jira) Pro';
          else if (product === 'wiki') text += 'Wiki (Confluence) Pro';
          else if (product === 'standups') text += 'Check-ins Pro';
          if (index !== products.length - 1) text += ', ';
        });

        return text;
      } else {
        if (info.plan_id) {
          let plan = this.state.pricings
            .filter((p) => !p.key)
            .find((plan) => info.plan_id == plan.plan_id);
          if (plan) {
            return plan.name + '(' + plan.billing_cycle + ')';
          } else if (info.plan_id == 'price_1Hz1ShHJhp7EYP6g36Xv9aLn') {
            return 'Troopr Monthly 19$';
          } else if (info.plan_id == 'price_1HK0ZIHJhp7EYP6gMdF3c13p') {
            return 'Troopr Pro Yearly';
          } else if (info.plan_id == 'price_1HK0X6HJhp7EYP6gZbh03F2k') {
            return 'Troopr Starter Yearly';
          } else if (info.plan_id == 'price_1H7bjfHJhp7EYP6gx97AVKSn') {
            return 'Troopr Starter Monthly';
          } else if (info.plan_id == 'price_1H6xUGHJhp7EYP6gFzgxzjHy') {
            return 'Troopr Pro Monthly';
          } else if (info.plan_id == 'price_1H6xTfHJhp7EYP6glq6N9wMI') {
            return 'Troopr Pro Monthly';
          } else if (info.plan_id == 'plan_FiFBie8XpLdC3U') {
            return 'Troopr Pro Monthly (Per user $2)';
          } else {
            return 'Troopr Plan';
          }
        }
      }
    }

    // return "Pro";
  };
  updatePayment = (payment) => {
    this.setState({ info: payment });
  };
  getButton = (plan_id) => {
    const { workspace } = this.props;
    const { info } = this.state;
    if (!plan_id && workspace.billing_status && workspace.is_enterprise) {
      return null;
    } else if (info && info.payment_app === 'appsumo') {
      return null;
    } else if (plan_id && plan_id == 'custom_pricing') {
      return (
        <Button onClick={this.customPricing} type='primary' key='billing'>
          Chat with us
        </Button>
      );
    } else if (
      workspace.billing_status !== 'trial' &&
      workspace.billing_status !== 'free' &&
      workspace.billing_status !== 'grace_period' &&
      !this.props.isAdmin
    ) {
      return (
        <Button onClick={this.showPermissionError} type='primary' key='billing'>
          Manage
        </Button>
      );
    } else {
      let url =
        window.location.origin + '/troopr_billing/' + this.props.workspace._id;
      let text = 'Manage';
      if (plan_id) {
        url += '?plan_id=' + plan_id;
        text = 'Choose';
      }
      return (
        <Button href={url} type='primary' key='billing'>
          {text}
        </Button>
      );
    }
  };
  showPermissionError = () => {
    message.error({
      content:
        "You don't have permission to perform this action. Only workspace admin can manage billing.",
    });
  };

  pricingPageQuestion = () => {
    localStorage.setItem('TROOPR_DRIFT_APP_MESSAGE', 'Query on pricing');
    this.openChatWindow('Query on pricing');
  };

  chooseUnlimitedEnterprisePlan = () => {
    localStorage.setItem(
      'TROOPR_DRIFT_APP_MESSAGE',
      'Query on Enterprise plan'
    );
    this.openChatWindow('Query on Enterprise plan');
  };

  customPricing = () => {
    localStorage.setItem('TROOPR_DRIFT_APP_MESSAGE', 'Query on Custom pricing');
    this.openChatWindow('Query on Custom pricing');
  };

  changePlan = () => {
    localStorage.setItem('TROOPR_DRIFT_APP_MESSAGE', 'Query on Change plan');
    this.openChatWindow('Query on Change plan');
  };

  openChatWindow = (msg) => {
    sendMessageOnchat(msg);
  };

  showComparison = () => {
    Modal.info({
      title: 'Self Service vs Enterprise',
      width: 800,
      maskClosable: true,
      content: (
        <Row style={{ marginTop: 32 }} gutter={[16, 16]}>
          <Col span={12}>
            <Card title='Self Service Plan Features'>
              ✔️ Flat pricing
              <Divider></Divider>
              ✔️ Limited features
              <Divider></Divider>
              ✔️ Standard Support
              <br />
              ✔️ Credit Card Payment only
              <br />
              <br />
              <Text>ℹ️ Choose a self service plan to see more</Text>
            </Card>
          </Col>
          <Col span={12}>
            <Card title='Enterprise Plan Features'>
              ✔️ Custom pricing
              <Divider></Divider>
              ✔️ Unlimited features
              <Divider />
              ✔️ Prioritized 24/7 Email & Chat Support
              <br />
              ✔️ Multiple Payment Methods
              <br />
              ✔️ Payment via PO/Invoice
              <br />
              ✔️ Multi-product Bundle Discount
              <br />
              ✔️ Custom Contract
              <br />
              ✔️ Dedicated Success Manager
              <br />
              ✔️ Prioritized Feature Requests
              <br />
              ✔️ Implementation Support
              <br />
              ✔️ Rollout and Adoption Guidance
              <br />
              ✔️ Security Assessment
              <br />
              ✔️ Vendor Evaluation
              <br />
              ✔️ Customizations to DPA, ToS, SLA
              <br />
              ✔️ Master Service Agreement
              <br />
              ✔️ Extended Evaluation Period
              <br />
              ✔️ Free Staging Setup
              <br />
            </Card>
          </Col>
        </Row>
      ),
      onOk() { },
    });
  };

  // showPlans = (isPlanMode) => {
  //   this.setState({
  //     showSelfPlans: isPlanMode,
  //   });
  // };
  getLimitsText = (limits) => {
    if (limits) {



      const usersPercent = limits.allowedActiveUsers > 0 ? Math.round((limits.currentActiveUsers / limits.allowedActiveUsers) * 100) : 0;
      const configPercent = limits.allowedActiveConfig > 0 ? Math.round((limits.currentActiveConfig / limits.allowedActiveConfig) * 100) : 0;
      const usersStatus = usersPercent >= 90 ? 'exception' : usersPercent >= 70 ? 'normal' : 'success';
      const configStatus = configPercent >= 90 ? 'exception' : configPercent >= 70 ? 'normal' : 'success';
      return <div style={{ display: 'flex', gap: 32 }}>
        <div style={{ minWidth: 180 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
            <UserOutlined style={{ color: '#8c8c8c', fontSize: 13 }} />
            <Text type='secondary' style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Active Users</Text>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
            <Text style={{ fontSize: 22, fontWeight: 700, lineHeight: 1 }}>{limits.currentActiveUsers}</Text>
            <Text type='secondary' style={{ fontSize: 14 }}>/ {limits.allowedActiveUsers}</Text>
          </div>
          <Progress percent={usersPercent} status={usersStatus} size='small' showInfo={false} />
        </div>

        <div style={{ width: 1, background: '#f0f0f0' }} />

        <div style={{ minWidth: 180 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
            <SettingOutlined style={{ color: '#8c8c8c', fontSize: 13 }} />
            <Text type='secondary' style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Configurations</Text>
          </div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 6 }}>
            <Text style={{ fontSize: 22, fontWeight: 700, lineHeight: 1 }}>{limits.currentActiveConfig}</Text>
            <Text type='secondary' style={{ fontSize: 14 }}>/ {limits.allowedActiveConfig}</Text>
          </div>
          <Progress percent={configPercent} status={configStatus} size='small' showInfo={false} />
        </div>
      </div>
    } else {
      return null
    }
  }
  getText = () => {
    let workspace = this.props.workspace;
    const isLimitBased = this.state.info && this.state.info.billing_type === 'limit_based';
    const limits = isLimitBased
      ? (this.state.info.limits || { currentActiveUsers: 0, currentActiveConfig: 0, allowedActiveUsers: 0, allowedActiveConfig: 0 })
      : null;
    let text = '';
    if (workspace._id) {
      if (
        workspace.billing_status === 'trial' ||
        workspace.billing_status === 'grace_period'
      ) {
        text = (
          <Fragment>
            {' '}
            <Title level={4}> Trial</Title>
            <Alert
              // message=  {moment(new Date())<=moment(wso orkspace.trial_end)?(moment(workspace.trial_end).diff(new Date(),'days')<1?'14 day trial period expires today.':`${moment(workspace.trial_end).diff(new Date(),'days')} days left of 14 day trial period.`) +" Choose a plan to continue using Troopr.":"Your trial period has expired. Choose a plan to keep working without interruption."}
              message={
                moment(new Date()) <= moment(workspace.trial_end)
                  ? (moment(workspace.trial_end).diff(new Date(), 'days') < 1
                    ? 'Your trial period expires today.'
                    : `${moment(workspace.trial_end).diff(
                      new Date(),
                      'days'
                    )} days left in your trial period.`) +
                  ' Choose a plan to continue using Troopr.'
                  : 'Your trial period has expired. Choose a plan to keep working without interruption.'
              }
              // description="Your trial is expiring in 14 days. Choose a plan to keep working without interruption"
              type={
                moment(new Date()) > moment(workspace.trial_end)
                  ? 'warning'
                  : 'info'
              }
              showIcon
            />

            {limits && <>
              <Divider style={{ margin: '0 0 16px 0' }} />
              {this.getLimitsText(limits)}
            </>}
            {/* <br />
            <Button
              onClick={() => {
                this.showPlans(true);
              }}
            >
              Choose Self Service Plan
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={this.chooseUnlimitedEnterprisePlan}>
              Choose Unlimited Enterprise Plan
            </Button>
            <br />
            <br /> */}
            {/* <Link onClick={this.showComparison}>Compare Self Service vs Enterprise Plans</Link> */}
          </Fragment>
        );
      } else if (workspace.billing_status == 'paid' || workspace.billing_status == 'free') {

        text = (
          <Fragment>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                {/* Plan name section */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
                  <Title level={3} style={{ margin: 0 }}>{this.getPlan()}</Title>
                  <Tag color={workspace.billing_status === 'free' ? 'default' : 'purple'} style={{ fontSize: 12, padding: '2px 10px', borderRadius: 20 }}>
                    {workspace.billing_status === 'free' ? 'Free' : 'Active'}
                  </Tag>
                </div>

                <Divider style={{ margin: '0 0 16px 0' }} />

                {/* Usage stats */}
                {limits && this.getLimitsText(limits)}
              </div>

              {workspace.billing_status !== 'free' && (
                <Button onClick={this.changePlan} style={{ marginLeft: 24 }}>Change Plan</Button>
              )}
            </div>
          </Fragment>
        );
      } else if (
        workspace.billing_status == 'grace_payment_failed' ||
        workspace.billing_status == 'payment_failed'
      ) {
        text = (
          <Fragment>
            {(this.state.info.plan_id || this.state.info.length > 0) && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 24
                  }}
                >
                  <Title level={4}> {this.getPlan()}</Title>

                </div>
                <Button onClick={this.changePlan}>Change Plan</Button>
              </div>
            )}

            <Alert
              message='Payment towards your Troopr subscription was unsucessful. Click on Manage button to update your billing information to keep working without interruption.'
              // description="Your trial is expiring in 14 days. Choose a plan to keep working without interruption"
              type='error'
              showIcon
            />
          </Fragment >
        );
      } else {
        text = (
          <Fragment>
            <div>
              <strong>{this.props.workspace.name}</strong> is currently on the{' '}
              <strong>Enjo plan</strong>.
            </div>
          </Fragment>
        );
      }
    }

    return text;
  };

  manageAddOn = (planId, action, planName) => {
    this.setState({ addOnModal: { planId, action, planName, qty: 1, submitting: false } });
  };

  submitAddOn = async () => {
    const { addOnModal, info } = this.state;
    if (!addOnModal) return;
    const { planId, action, qty } = addOnModal;
    this.setState({ addOnModal: { ...addOnModal, submitting: true } });
    try {
      const res = await axios.post(
        '/auth/payment/' + this.props.match.params.wId + '/addon',
        { plan_id: planId, quantity: qty, action }
      );
      if (res.data.success) {
        // Optimistically set pending_action in local state immediately so UI
        // shows the processing state right away without waiting for a DB round-trip
        this.setState({
          addOnModal: null,
          info: {
            ...info,
            pending_action: { type: 'add_on', plan_id: planId, action, quantity: qty },
          },
        });
        // Start polling — picks up real DB state once webhook clears pending_action
        this.getBillingData();
      } else {
        message.error(res.data.error || 'Failed to update add-on');
        this.setState({ addOnModal: { ...addOnModal, submitting: false } });
      }
    } catch (err) {
      message.error('Failed to update add-on');
      this.setState({ addOnModal: { ...addOnModal, submitting: false } });
    }
  };

  renderAddOnModal = () => {
    const { addOnModal, info } = this.state;
    if (!addOnModal) return null;
    const { planId, action, qty, submitting } = addOnModal;
    const isRemoving = action === 'decrement';
    const currentQty = ((info && info.add_ons) || []).find(a => a.price_id === planId)?.quantity || 0;
    const newQty = isRemoving ? currentQty - qty : currentQty + qty;
    const removesAll = isRemoving && newQty <= 0;

    const setQty = (val) => this.setState({ addOnModal: { ...addOnModal, qty: val } });

    return (
      <Modal
        visible
        title={isRemoving ? 'Remove Add-on Units' : 'Add Add-on Units'}
        width={420}
        onCancel={() => this.setState({ addOnModal: null })}
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => this.setState({ addOnModal: null })}>Cancel</Button>
            <Button
              type='primary'
              danger={isRemoving}
              loading={submitting}
              onClick={this.submitAddOn}
            >
              {isRemoving ? 'Yes, Remove' : 'Yes, Add'}
            </Button>
          </div>
        }
      >

        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '8px 16px',
          marginBottom: '16px',

          background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0',
        }}>
          <Text type='secondary' style={{ fontSize: 13, flex: 1 }}>
            Units to {isRemoving ? 'remove' : 'add'}:
          </Text>
          <Button
            size='small'
            icon={<MinusOutlined />}
            disabled={qty <= 1}
            onClick={() => setQty(Math.max(1, qty - 1))}
          />
          <InputNumber
            min={1}
            max={isRemoving ? currentQty : undefined}
            value={qty}
            size='small'
            style={{ width: 64 }}
            onChange={(val) => setQty(Math.min(isRemoving ? currentQty : Infinity, Math.max(1, val || 1)))}
          />
          <Button
            size='small'
            icon={<PlusOutlined />}
            disabled={isRemoving && qty >= currentQty}
            onClick={() => setQty(isRemoving ? Math.min(currentQty, qty + 1) : qty + 1)}
          />
        </div>

        <div style={{
          padding: '10px 14px', borderRadius: 6,
          background: removesAll ? '#fff2f0' : isRemoving ? '#fff7e6' : '#f6ffed',
          border: `1px solid ${removesAll ? '#ffccc7' : isRemoving ? '#ffe7ba' : '#b7eb8f'}`,
        }}>
          {removesAll ? (
            <Text type='danger' style={{ fontSize: 13 }}>
              This will <Text strong type='danger'>remove the add-on entirely</Text> from your subscription.
            </Text>
          ) : (
            <Text style={{ fontSize: 13 }}>
              Subscription changes: <Text strong>{currentQty}</Text>
              <Text type='secondary'> → </Text>
              <Text strong style={{ color: isRemoving ? '#d46b08' : '#389e0d' }}>
                {newQty} unit{newQty !== 1 ? 's' : ''}
              </Text>
            </Text>
          )}
          <Text type='secondary' style={{ fontSize: 12, display: 'block', marginTop: 4 }}>
            Your next invoice will be prorated accordingly.
          </Text>
        </div>

      </Modal>
    );
  };


  renderAddOns = () => {
    const { pricings, info } = this.state;
    const { workspace } = this.props;

    if (workspace.billing_status !== 'paid') return null;

    const subscribedPlanIds = (info && info.plans) || [];
    const addOnPlans = pricings.filter(
      (p) => p.type === 'add_on' && !p.is_archived && subscribedPlanIds.includes(p.parent_plan_id)
    );
    if (addOnPlans.length === 0) return null;

    const subscribedAddOns = (info && info.add_ons) || [];
    const pendingAction = info && info.pending_action;
    const hasPending = !!(pendingAction && pendingAction.type === 'add_on');

    return (
      <Col span={24} style={{ marginTop: 16 }}>
        <Card
          title='Add-ons'
          extra={hasPending && (
            <Tag icon={<SyncOutlined spin />} color='processing'>
              Processing change…
            </Tag>
          )}
        // bodyStyle={{ padding: 0 }}
        >
          {addOnPlans.map((plan, idx) => {
            const planId = plan._id?.$oid || plan._id;
            const subscribed = subscribedAddOns.find(a => a.price_id === plan.plan_id);
            const currentQty = subscribed ? subscribed.quantity : 0;
            const isSubscribed = currentQty > 0;
            const isPending = hasPending && pendingAction.plan_id === plan.plan_id;

            return (
              <div
                key={planId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '16px 24px',
                  borderBottom: idx < addOnPlans.length - 1 ? '1px solid #f0f0f0' : 'none',
                  borderLeft: isPending ? '3px solid #1890ff' : isSubscribed ? '3px solid #722ed1' : '3px solid transparent',
                  background: isPending ? '#e6f7ff' : isSubscribed ? '#fdf9ff' : '#fff',
                  opacity: hasPending && !isPending ? 0.5 : 1,
                  transition: 'all 0.3s',
                }}
              >
                {/* Name + description */}
                <div style={{ flex: '0 0 220px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Text strong style={{ fontSize: 14 }}>{plan.name}</Text>
                    {isPending ? (
                      <Tag icon={<SyncOutlined spin />} color='processing' style={{ borderRadius: 20, fontSize: 11 }}>
                        Processing
                      </Tag>
                    ) : isSubscribed && (
                      <Tag color='purple' style={{ borderRadius: 20, fontSize: 11 }}>Active</Tag>
                    )}
                  </div>
                  {plan.desc && plan.desc[0] && (
                    <Text type='secondary' style={{ fontSize: 12 }}>{plan.desc[0]}</Text>
                  )}
                </div>

                {/* Price */}
                <div style={{ flex: '0 0 120px' }}>
                  <Text style={{ fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{plan.price}</Text>
                  {plan.features && plan.features.static_text && (
                    <Text type='secondary' style={{ fontSize: 11, display: 'block', marginTop: 2 }}>
                      {plan.features.static_text}
                    </Text>
                  )}
                </div>

                {/* Current qty */}
                <div style={{ flex: '0 0 140px' }}>
                  {isSubscribed ? (
                    <div style={{
                      display: 'inline-flex', alignItems: 'center', gap: 6,
                      background: isPending ? '#bae7ff' : '#f9f0ff', borderRadius: 6, padding: '4px 12px',
                    }}>
                      <CheckCircleOutlined style={{ color: isPending ? '#1890ff' : '#722ed1', fontSize: 13 }} />
                      <Text strong style={{ color: isPending ? '#1890ff' : '#722ed1', fontSize: 13 }}>
                        {currentQty} unit{currentQty > 1 ? 's' : ''}
                      </Text>
                    </div>
                  ) : (
                    <Text type='secondary' style={{ fontSize: 12 }}>Not subscribed</Text>
                  )}
                </div>

                {/* Action buttons */}
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    type='primary'
                    icon={isPending ? <SyncOutlined spin /> : <PlusOutlined />}
                    disabled={hasPending}
                    onClick={() => this.manageAddOn(plan.plan_id, 'increment', plan.name)}
                  >
                    Add
                  </Button>
                  {isSubscribed && (
                    <Button
                      danger
                      icon={isPending ? <SyncOutlined spin /> : <MinusOutlined />}
                      disabled={hasPending}
                      onClick={() => this.manageAddOn(plan.plan_id, 'decrement', plan.name)}
                    >
                      Remove
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </Card>
      </Col>
    );
  };

  render() {
    const { workspace } = this.props;
    let isUserPrivileged = this.props.WorkspaceAdmin;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
        {this.renderAddOnModal()}
        <PageHeader
          title='Billing'
          subTitle={
            <span>
              For any questions regarding our Plans visit the{' '}
              <a href='https://www.troopr.ai/pricing' target='_blank'>
                pricing page
              </a>{' '}
              or reach us at sales@troopr.io
            </span>
          }
        />
        {!this.state.loading && (
          <div
            // style={{height:700,overflow: "scroll"}} ̰ ̰
            style={{
              flex: 1,
              paddingBottom: 20,
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            {this.state.info && this.state.info.payment_app == 'jira' ? (
              <Row
                style={{
                  // padding: "32px 24px 0px 24px",
                  padding: '0px 24px 0px 24px',
                }}
                gutter={[16, 16]}
              >
                {' '}
                <Col span={24}>
                  {' '}
                  <JiraBilling
                    payment={this.state.info}
                    workspace={this.props.workspace}
                    updatePayment={this.updatePayment}
                    isUserPrivileged={isUserPrivileged}
                  />{' '}
                </Col>
              </Row>
            ) : (
              <Row
                style={{
                  // padding: "32px 24px 0px 24px",
                  padding: '0px 24px 0px 24px',
                }}
                gutter={[16, 16]}
              >
                {workspace.billing_status == 'trial' ||
                  workspace.billing_status == 'free' ||
                  workspace.billing_status == 'grace_period' ? (
                  <>
                    <Col span={24}>
                      <Card
                        title='Current Plan(s)'
                        extra={
                          workspace.billing_status !== 'trial' &&
                            workspace.billing_status !== 'free' &&
                            workspace.billing_status !== 'grace_period' &&
                            this.state.info.payment_app !== 'jira'
                            ? this.getButton()
                            : null
                        }
                      >
                        {this.getText()}

                      </Card>
                      {workspace.billing_status == 'free' && (
                        <Title level={4} style={{ marginTop: 20 }}>
                          Upgrade Options
                        </Title>)}
                      <TrialPage
                        pricings={this.state.pricings}
                        showPlans={this.showPlans}
                        workspace={workspace}
                        selectProduct={this.selectProduct}
                        selectedProduct={[]}
                        setBillingData={this.setBillingData}
                        getButton={this.getButton}
                        chooseUnlimitedEnterprisePlan={() =>
                          this.chooseUnlimitedEnterprisePlan()
                        }
                      />

                      <Link onClick={this.showComparison}>
                        Compare Self Service vs Enterprise Plans
                      </Link>

                    </Col>
                  </>
                ) : (
                  /* : workspace.billing_status == "paid" ? (
                  <Col span={24}>
                    <Card
                      title='Current Plan(s)'
                      extra={
                        workspace.billing_status !== "trial" && workspace.billing_status !== "grace_period" && this.state.info.payment_app !== "jira"
                          ? this.getButton()
                          : null
                      }
                    >
                      <div>{this.getText()}</div>
                    </Card>
                  </Col>
                )  */
                  <>
                    <Col span={24}>
                      <Card
                        title='Current Plan(s)'
                      // extra={
                      //   workspace.billing_status !== 'trial' &&
                      //     workspace.billing_status !== 'grace_period' &&
                      //     this.state.info.payment_app !== 'jira'
                      //     ? this.getButton()
                      //     : null
                      // }
                      >
                        <div>{this.getText()}</div>
                      </Card>
                    </Col>
                    {this.renderAddOns()}
                  </>
                )}

                <br />
                <Col span={24}>
                  <Button
                    type='text'
                    icon={<QuestionCircleOutlined />}
                    onClick={this.pricingPageQuestion}
                  >
                    Got questions? Chat with us
                  </Button>
                </Col>
              </Row>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workspace: state.common_reducer.workspace,

    skills: state.skills.skills,
    WorkspaceAdmin: state.common_reducer.isAdmin,
  };
};

export default withRouter(connect(mapStateToProps, { setDriftState })(Billing));
